export default __webpack_public_path__ + "static/media/Pink flare_primary.eb9f0d3d.jpg";